import { useState } from 'react'

import { InputForm } from '@/components/Consultation/steps/Landing/InputForm'
import { Modal } from '@/components/Modal'
import { useQuestion } from '@/hooks/useQuestion'
import { getSlugTranslation } from '@/locale/utils'

export const FollowUpComposer = ({ onCancel }: { onCancel: () => void }) => {
  const [showDiscardConfirmation, setShowDiscardConfirmation] = useState(false)
  const { attachments, question, resetQuestion } = useQuestion()

  const discardFollowUp = () => {
    resetQuestion()
    setShowDiscardConfirmation(false)
    onCancel()
  }

  const cancelFollowUp = () => {
    if (!question.question?.trim()?.length && !attachments?.length) {
      return discardFollowUp()
    }

    setShowDiscardConfirmation(true)
  }

  return (
    <>
      <section className="drop-shadow-chat-bubble flex w-full flex-col gap-4 rounded-2xl bg-white p-4" data-testid="follow-up-composer">
        <div className="flex items-center justify-between">
          <p className="text-gray-text text-sm font-semibold uppercase">{getSlugTranslation('general.consultation.followupCard.yourMessage')}</p>
          <button className="text-primary px-2.5 py-2 text-sm font-bold" onClick={cancelFollowUp} type="button">
            {getSlugTranslation('button.cancel')}
          </button>
        </div>

        <InputForm inlineActions />

        <p className="rounded-lg bg-gray-100 p-2 text-center text-sm">{getSlugTranslation('general.consultation.followupCard.hint')}</p>
      </section>

      <Modal
        actions={[
          {
            label: getSlugTranslation('general.consultation.followUp.discardModal.discardButton'),
            onClick: discardFollowUp
          },
          {
            label: getSlugTranslation('general.consultation.followUp.discardModal.keepWriting'),
            onClick: () => setShowDiscardConfirmation(false),
            variant: 'outline'
          }
        ]}
        dataTestId="follow-up-discard-dialog"
        isOpen={showDiscardConfirmation}
        title={getSlugTranslation('general.consultation.followUp.discardModal.title')}
      >
        <p className="text-center">{getSlugTranslation('general.consultation.followUp.discardModal.description')}</p>
      </Modal>
    </>
  )
}
